import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils.ts";
import { ColorBlock } from "@repo/ui/color-block";
import type { ColorBlockColor } from "@repo/ui/color-block";
import { VisualWrapper } from "@/components/common/visual/visual.component";
import { ActionLink } from "@/components/common/actions/actions.component";
import type { VisualType } from "@/lib/types";
import type { CardData } from "@/components/navigation/navigation.types";
import type { DesignColorValue } from "@/lib/design-colors";
type ImageCardSize = "large" | "medium" | "small";
interface ImageCardProps {
  card: CardData;
  size: ImageCardSize;
  colour?: DesignColorValue | null;
}
const sizeToColorBlockVariant: Record<ImageCardSize, "rectangle-sm" | "square"> = {
  large: "rectangle-sm",
  medium: "square",
  small: "square"
};
export function ImageCard(t0) {
  const $ = _c(29);
  const {
    card,
    size,
    colour
  } = t0;
  const hasVisual = Boolean(card.visual?.mediaSource);
  const hasColour = !hasVisual && Boolean(colour);
  const t1 = size === "small" ? "rounded-sm" : "rounded-md";
  const t2 = !hasVisual && !hasColour && "bg-surface-base-secondary";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = cn("relative h-full overflow-hidden", t1, t2);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== card.visual || $[4] !== colour || $[5] !== hasColour || $[6] !== hasVisual || $[7] !== size) {
    t4 = hasVisual ? <VisualWrapper visual={card.visual as VisualType} className={cn("h-full transition-transform duration-500 ease-out group-hover:scale-105", size === "large" && "min-h-[270px]", size === "medium" && "aspect-[217/270]", size === "small" && "aspect-[133/160]")} visualClassName="h-full w-full" extraImageProps={{
      sizes: size === "large" ? "(max-width: 1440px) 33vw, 480px" : "(max-width: 1440px) 16vw, 240px",
      cropAspect: size === "large" ? 1.7777777777777777 : size === "medium" ? 0.8037037037037037 : 0.83125
    }} imgClassName="object-cover" /> : hasColour ? <ColorBlock variant={sizeToColorBlockVariant[size]} color={colour as ColorBlockColor} className={cn(size === "large" && "min-h-[270px]", size === "medium" && "aspect-[217/270]", size === "small" && "aspect-[133/160]")} /> : <div className={cn(size === "large" && "min-h-[270px]", size === "medium" && "aspect-[217/270]", size === "small" && "aspect-[133/160]")} />;
    $[3] = card.visual;
    $[4] = colour;
    $[5] = hasColour;
    $[6] = hasVisual;
    $[7] = size;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = hasVisual && "bg-gradient-to-t from-black/70 to-transparent";
  const t6 = size === "small" && "p-2";
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = cn("absolute inset-x-0 bottom-0 p-4", t5, t6);
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== card.headline || $[13] !== size) {
    t8 = card.headline && <h3 className={cn("text-white", size === "large" && "typography-component-md-medium", size === "medium" && "typography-component-md-medium", size === "small" && "typography-component-xs-medium")}>{card.headline}</h3>;
    $[12] = card.headline;
    $[13] = size;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== card.description || $[16] !== size) {
    t9 = size === "large" && card.description && <p className="typography-body-xs-regular mt-2 text-white/80">{card.description}</p>;
    $[15] = card.description;
    $[16] = size;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
    t10 = <div className={t7}>{t8}{t9}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t3 || $[24] !== t4) {
    t11 = <div className={t3}>{t4}{t10}</div>;
    $[22] = t10;
    $[23] = t3;
    $[24] = t4;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const content = t11;
  if (card.action?.to) {
    let t12;
    if ($[26] !== card.action.to || $[27] !== content) {
      t12 = <ActionLink actionTo={card.action.to} className="group block h-full">{content}</ActionLink>;
      $[26] = card.action.to;
      $[27] = content;
      $[28] = t12;
    } else {
      t12 = $[28];
    }
    return t12;
  }
  return content;
}